import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { CircularProgress, Container, Typography } from '@material-ui/core';

// Redux
import { connect } from 'react-redux';
import { setSuccess, clearErrors, setAlert } from '../../../../redux/actions/alertActions';

// API
import { getFloor } from '../../../../api';

// Components
import FloorForm from '../../../../components/FloorForm';

class Floor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToFloors: false,
      floor: null,
      isLoading: false
    };
  }

  componentDidMount() {
    const floorID = this.props.match?.params?.id;

    this.setState({ isLoading: true });
    getFloor(floorID).then(floor => {
      this.setState({ floor: floor, isLoading: false });
    }).catch(error => {
      this.setState({ isLoading: false });
      this.props.setError(error ? error : 'Error: Unable to retrieve floor.');
    });
  }

  render() {
    return this.state.redirectToFloors || !this.props.setupMode ? <Redirect to='/admin/floors' /> : (
      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
          <Typography variant='h1'>Update Floor</Typography>
          {this.state.isLoading && <CircularProgress style={{ color: this.props.statusColor.main }} />}
        </div>

        {this.state.floor != null &&
        <FloorForm onSuccess={() => this.setState({ redirectToFloors: true })} floor={this.state.floor} />}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  statusColor: state.status.schoolStatus.getColor(),
  setupMode: state.setupMode.mode || state.setupMode.isLoading
});

const mapDispatchToProps = dispatch => ({
  setError: (msg) => setAlert(dispatch, msg),
  setSuccess: (msg) => setSuccess(dispatch, msg),
  clearErrors: () => dispatch(clearErrors())
});

Floor.propTypes = {
  setError: PropTypes.func,
  setSuccess: PropTypes.func,
  clearErrors: PropTypes.func,
  match: PropTypes.object.isRequired,
  statusColor: PropTypes.object.isRequired,
  setupMode: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Floor));
